/* eslint-disable eqeqeq */
import { ACTIONS } from '../const';
import objectRecord from './object_record';
import R from 'ramda';

const defaultState = [];
const notificationRecord = objectRecord({
    key: null,
    title: null,
    text: null,
    dismissable: true,
    icon: null,
});

export default function handler(state = defaultState, action) {
    const { type, payload } = action;

    switch (type) {
        case ACTIONS.NEW_NOTIFICATION:
            // return state.push()
            return R.append(notificationRecord(payload), state);
        case ACTIONS.REMOVE_NOTIFICATION:
            return R.filter(n => n.key != payload, state);
        case ACTIONS.UPDATE_NOTIFICATION:
            return R.map(n => {
                if (n.key === payload.key) {
                    return notificationRecord(n, payload);
                }
                return n;
            }, state);
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/notifications.js